export interface PublicUser {
  id: number
  name: string
}
export interface CurrentUser extends PublicUser {
  email: string
}
export interface ItemInput {
  name: string
  url?: string | null
  image_url?: string | null
  notes?: string | null
}
export interface OwnedItem extends ItemInput {
  id: number
}
export interface Item extends OwnedItem {
  purchased: boolean
  purchased_by?: number
  purchased_at?: string
}
export interface GiftList<T extends OwnedItem = OwnedItem> {
  id: number
  user_id: number
  items: T[]
}
export interface ProductPreview {
  title: string | null
  image_url: string | null
}
export interface ApiEnvelope<T> {
  data: T
  error?: string
  errors?: string[]
  code?: string
}
export class ApiError extends Error {
  constructor(
    message: string,
    public code?: string
  ) {
    super(message)
  }
}
export function errorMessage(error: unknown): string {
  return error instanceof Error
    ? error.message
    : "Something went wrong. Please try again."
}
export async function readJson<T>(response: Response): Promise<ApiEnvelope<T>> {
  const json: unknown = await response.json()
  return json as ApiEnvelope<T>
}
